import React, { useState } from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { useCartContext } from 'src/lib/contexts/CartContext'

export const FooterControl = () => {
  // Temporary state - will be integrated with cart context later
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()

  const handleConfigChange = (updates: Record<string, any>) => {
    setCartUIConfigData(updates, 'FOOTER')
  }

  return (
    <div className='flex flex-col gap-3'>
      {/* General Section */}
      <div className='flex flex-col gap-2'>
        <div className='grid w-full gap-2 grid-cols-2'>
          <ColorPickerV2
            label='Background'
            color={cartUIData.footer.backgroundColor}
            onChange={color => handleConfigChange({ backgroundColor: color })}
          />
          <ColorPickerV2
            label='Text'
            color={cartUIData.footer.textColor}
            onChange={color => handleConfigChange({ textColor: color })}
          />
          <ColorPickerV2
            label='Savings'
            color={cartUIData.footer.savingsColor}
            onChange={color => handleConfigChange({ savingsColor: color })}
          />
        </div>
      </div>
    </div>
  )
}
